import React from "react";
import Reveal from "./Reveal";
import { SITE, CONTACT } from "../../content/site";
import { useLanguage } from "../../i18n/LanguageContext";

// A single quiet invitation: just the address, with its drawn underline.
export default function Contact() {
  const { t } = useLanguage();
  const eyebrow = t(CONTACT.eyebrow);
  return (
    <section id="contact" className="dp-section dp-contact" aria-label={eyebrow}>
      <Reveal as="p" className="dp-eyebrow">
        {eyebrow}
      </Reveal>
      <Reveal delay={80}>
        <a className="dp-contact__email" href={`mailto:${SITE.email}`}>
          {SITE.email}
        </a>
      </Reveal>
    </section>
  );
}
